<template>

  <div class="buscar-navbar">
    <BuscadorField :dataset="dataset" />
  </div>
    
</template>
<script>
  import BuscadorField from './BuscadorField.vue'

  export default {
    name: 'BuscadorMenu',
    props: {
      dataset: Array
    },
    components: {
      BuscadorField
    }
  }
    


</script>